import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class FortknoxService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }
    
    async queueManagerActivate(data) {
        const pos = getPosition();
        const response = await API.service('queueManagerActivate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async queueManagerCountTask(data) {
        const pos = getPosition();
        const response = await API.service('queueManagerCountTask', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async queueManagerPause(data) {
        const pos = getPosition();
        const response = await API.service('queueManagerPause', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async queueManagerResume(data) {
        const pos = getPosition();
        const response = await API.service('queueManagerResume', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async queueManagerUpdateRate(data) {
        const pos = getPosition();
        const response = await API.service('queueManagerUpdateRate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async generateTxInfo(data) {
        const pos = getPosition();
        const response = await API.service('generateTxInfo', data, pos, this.changeAlert, null, null);

        return response?.data
    }
}